<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    Mail
                </mat-icon>
                <span>
                    Email Message: {{ itemEnvelope?.Document?.Item?.Name }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit Message: {{ itemEnvelope?.Document?.Item?.EmailMessageId }} - {{ itemEnvelope?.Document?.Item?.Name }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div style="display: flex;flex-direction: column;">
                (FromInput)
                <br /><br />
                (ToInput)
                <br /><br />
                <button mat-button (click)="toggleCcBccFieldVisibility()">
                    <mat-icon class="material-symbols-outlined" matTooltip="Toggle CC and BCC fields">
                        {{ ccBccToggleButtonDynamicIconName }}
                    </mat-icon>
                </button>
            </div>
            <mat-tab-group>
                <br />
                <mat-tab label="EmailMessage">
                    <br />
                    <mat-form-field style="width:100%;height: 40%;" appearance="outline">
                        <mat-label>Body</mat-label>
                        <textarea matInput name="messageBody" rows="20" placeholder="" [(ngModel)]="itemEnvelope!.Document!.Item!.Body!" style="font-family: 'Source Code Pro', monospace;"></textarea>
                    </mat-form-field>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

